import axios from '@/utils/axios'

/**
 *  获取模版列表
 */
export function templateList(
  template_type,
  is_record = 0,
  is_cloud_visit = ''
) {
  const parameter = { template_type, is_record, is_cloud_visit }
  return axios.formRequest.post('crm/website/template/templateList', {
    ...parameter
  })
}

/**
 *  模版状态设置
 */
export function setStatus(template_id, function_name) {
  return axios.formRequest.post('crm/website/template/setStatus', {
    template_id,
    function_name
  })
}

/**
 *  模版删除
 */
export function delTemplate(template_id) {
  return axios.formRequest.post('crm/website/template/del', {
    template_id
  })
}

/**
 *  拜访任务属性配置 提交时间配置列表
 */
export function temporaryList(page) {
  return axios.formRequest.post('crm/website/Attribute/temporaryList', {
    page
  })
}

/**
 *  拜访任务属性配置 提交时间配置删除
 */
export function temporaryDel(id) {
  return axios.formRequest.post('crm/website/Attribute/temporaryDel', {
    id
  })
}

/**
 *  拜访任务属性配置 提交时间配置添加
 */
export function temporaryAdd(parameter) {
  return axios.formRequest.post('crm/website/Attribute/temporaryAdd', parameter)
}

/**
 *  拜访任务属性配置 提交时间配置编辑
 */
export function temporaryEditor(parameter) {
  return axios.formRequest.post(
    'crm/website/Attribute/temporaryEditor',
    parameter
  )
}

/**
 *  拜访任务属性配置 计划属性添加
 */
export function attributeSubmitAdd(parameter) {
  return axios.formRequest.post('crm/website/Attribute/submitAdd', parameter)
}

/**
 *  拜访任务属性配置 计划属性编辑
 */
export function attributeSubmitEditor(parameter) {
  return axios.formRequest.post('crm/website/Attribute/submitEditor', parameter)
}

/**
 *  拜访任务属性配置 计划属性删除
 */
export function attributeSubmitDel(id) {
  return axios.formRequest.post('crm/website/Attribute/submitDel', {
    id
  })
}

/**
 *  拜访任务属性配置 计划属性配置列表
 */
export function attributeSubmitList(page) {
  return axios.formRequest.post('crm/website/Attribute/submitList', {
    page
  })
}

/**
 *  移动端首页界面配置 crm页面列表
 */
export function moduleDepartmentList(module_type) {
  return axios.formRequest.post('crm/website/setting/moduleDepartmentList', {
    module_type
  })
}

/**
 *  移动端首页界面配置 crm列表 启用停用
 */
export function moduleDepartmentStop(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/moduleDepartmentStop',
    parameter
  )
}

/**
 *  移动端首页界面配置 crm／办公配置方案编辑
 */
export function moduleSettingEdit(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/moduleDepartmentEdit',
    parameter
  )
}

/**
 *  档案操作／审核列表
 */
export function clientOpreateList(scene, cls, is_no_del_doctor) {
  return axios.formRequest.post('crm/website/setting/clientOpreateList', {
    scene,
    cls,
    is_no_del_doctor
  })
}

/**
 *  档案 操作审批流 开启／关闭
 */
export function needApproval(category, is_need_approval, cls = 0) {
  return axios.formRequest.post('crm/website/setting/needApproval', {
    category,
    is_need_approval,
    cls
  })
}

/**
 *  审批流详情
 */
export function approvalFlowDetail(approval_flow_id, category, type_id) {
  return axios.formRequest.post('crm/website/approval/flowDetail', {
    approval_flow_id,
    category,
    type_id
  })
}

/**
 *  模版添加
 */
export function template_add(parameter) {
  return axios.formRequest.post('crm/website/template/add', parameter)
}

/**
 *  审批流设置
 */
export function approvalSet(parameter) {
  return axios.formRequest.post('crm/website/setting/approvalSet', parameter)
}

/**
 *  档案操作设置职位
 */
export function opreateSave(parameter) {
  return axios.formRequest.post('crm/website/setting/opreateSave', parameter)
}

/**
 *  档案多地址
 */
export function multAddressSet(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/multAddressSet',
    parameter
  )
}

/**
 *  模板已关联档案字段
 */
export function relevanceFieldList(parameter) {
  return axios.formRequest.post(
    'crm/website/template/relevanceFieldList',
    parameter
  )
}

/**
 *  设置默认模版
 */
export function setDefault(template_id) {
  return axios.formRequest.post('crm/website/template/setDefault', {
    template_id
  })
}

/**
 *  获取模板详情
 */
export function getTemplateInfo(template_id, visit_id, report_date_id) {
  // 无与伦比的天才代码 震惊世人的传参方式
  let parameter = { template_id, report_date_id }
  if (visit_id) {
    parameter.visit_id = visit_id
  }
  return axios.formRequest.post(
    'crm/website/template/getTemplateInfo',
    parameter
  )
}
/**
 *  按产品标签设置上报周期
 */
export function getDataReportGoodsLabel(is_look) {
  let parameter = { is_look }
  return axios.formRequest.post(
    'crm/website/template/getDataReportGoodsLabel',
    parameter
  )
}
/**
 *  编辑模版
 */
export function editor(parameter) {
  return axios.formRequest.post('crm/website/template/editor', parameter)
}

/**
 *  移动端首页界面配置 首页／仪表盘 列表
 */
export function homeModuleSettingList(module_type) {
  return axios.formRequest.post('crm/website/setting/homeModuleSettingList', {
    module_type
  })
}
/**
 *  移动端首页界面配置 首页／仪表盘 停用
 */
export function homeModuleSettingStop(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/homeModuleSettingStop',
    parameter
  )
}
/**
 *  移动端首页界面配置 首页／仪表盘 编辑
 */
export function homeModuleSettingEdit(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/homeModuleSettingEdit',
    parameter
  )
}
/**
 *  活动列表
 */
export function activityList(parameter) {
  return axios.formRequest.post('crm/website/activity/activityList', parameter)
}
// 市场活动列表获取分页信息
export function activityGetpagination(parameter) {
  return axios.formRequest.post(
    '/crm/website/activity/getListPageInfo',
    parameter
  )
}
/**
 *  活动形式列表
 */
export function activityTemplateList() {
  return axios.formRequest.post('crm/website/activity/activityTemplateList', {})
}
/**
 *  活动形式列表
 */
export function activityFormChooseList() {
  return axios.formRequest.post(
    'crm/website/activity/activityFormChooseList',
    {}
  )
}
/**
 *  异步导出活动接口
 */
export function exportActivity(parameter) {
  return axios.formRequest.post('crm/website/export/exportActivity', parameter)
}
/**
 *  活动详情
 */
export function activityInfo(activity_id) {
  return axios.formRequest.post('crm/website/activity/activityInfo', {
    activity_id
  })
}
/**
 *  活动详情 领导建议
 */
export function proposalList(task_id, type) {
  return axios.formRequest.post('crm/website/activity/proposalList', {
    task_id,
    type
  })
}
/**
 *  活动详情 执行活动详情 value
 */
export function implementActivityInfo(activity_id) {
  return axios.formRequest.post('crm/website/activity/implementActivityInfo', {
    activity_id
  })
}
/**
 *  活动详情 执行活动详情 title
 */
export function getImplementActivityField(activity_id) {
  return axios.formRequest.post(
    'crm/website/activity/getImplementActivityField',
    { activity_id }
  )
}
/**
 *  工作报告配置 获取 8日报配置 9月报填写节点
 */
export function getReportSetting(type) {
  return axios.formRequest.post('crm/website/setting/getReportSetting', {
    type
  })
}
/**
 *  工作报告配置  8日报配置 9月报 设置
 */
export function reportSetting(
  type,
  setting_json,
  type1,
  type2,
  setting_json1,
  setting_json2
) {
  return axios.formRequest.post('crm/website/setting/reportSetting', {
    type,
    setting_json,
    type1,
    type2,
    setting_json1,
    setting_json2
  })
}
/**
 *  工作报告配置 获周计划天数列表
 */
export function weekReportSettingList() {
  return axios.formRequest.post('crm/website/setting/weekReportSettingList', {})
}
/**
 *  工作报告配置 删除周计划配置
 */
export function deleteWeekReportSetting(crm_week_report_setting_id) {
  return axios.formRequest.post('crm/website/setting/deleteWeekReportSetting', {
    crm_week_report_setting_id
  })
}
/**
 *  工作报告配置 添加周计划天数配置
 */
export function createWeekReportSetting(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/createWeekReportSetting',
    parameter
  )
}
/**
 *  工作报告配置 修改周计划天数配置
 */
export function editorWeekReportSetting(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/editorWeekReportSetting',
    parameter
  )
}
/**
 *  活动详情 报销
 */
export function reimbursementThrough(parameters) {
  return axios.formRequest.post(
    'crm/website/activity/reimbursementThrough',
    parameters
  )
}
/**
 *  活动详情 上传活动附件
 */
export function uploadActivityEnclosure(activity_id, file_json, function_name) {
  return axios.formRequest.post(
    'crm/website/activity/uploadActivityEnclosure',
    {
      activity_id,
      file_json,
      function_name
    }
  )
}
/**
 *  工作报告 工作报告列表
 */
export function weekReportList(parameters) {
  return axios.formRequest.post('crm/website/report/weekReportList', parameters)
}
/**
 *  工作报告 工作周报详情
 */
export function webReportInfo(parameters) {
  return axios.formRequest.post('crm/website/report/webReportInfo', parameters)
}
/**
 *  工作报告 工作月报导出
 */
export function exportMonthReport(parameters) {
  return axios.formRequest.post(
    'crm/website/export/exportMonthReport',
    parameters
  )
}
/**
 *  工作报告 工作月报详情
 */
export function monthReportInfo(parameters) {
  return axios.formRequest.post(
    'crm/website/report/monthReportInfo',
    parameters
  )
}
/**
 *  工作时间 获取日历信息
 */
export function calendarList(year, month) {
  return axios.formRequest.post('crm/website/setting/calendarList', {
    year,
    month
  })
}
/**
 *  工作时间 设置日期
 */
export function setWorkDate(parameters) {
  return axios.formRequest.post('crm/website/setting/setWorkDate', parameters)
}
/**
 *  报表中心列表 岗位统计 1拜访 2协访
 */
export function quarterStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/quarterStatistical',
    parameters
  )
}
/**
 *  报表中心列表 部门统计 1拜访 2协访
 */
export function departmentStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/departmentStatistical',
    parameters
  )
}
/**
 *  报表中心列表 档案受访统计
 */
export function clientStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/clientStatistical',
    parameters
  )
}
/**
 *  报表中心列表 院内院外统计
 */
export function hospitalStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/hospitalStatistical',
    parameters
  )
}
/**
 *  报表中心列表 评分统计
 */
export function scoreStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/scoreStatistical',
    parameters
  )
}
/**
 *  报表中心列表 关注统计
 */
export function adviceStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/adviceStatistical',
    parameters
  )
}
/**
 *  报表中心列表 活动形式统计
 */
export function activityFormStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/activityFormStatistical',
    parameters
  )
}
/**
 *  报表中心列表 岗位活动统计
 */
export function quarterActivityStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/quarterActivityStatistical',
    parameters
  )
}
/**
 *  报表中心列表 部门活动统计
 */
export function departmentActivityStatistical(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/departmentActivityStatistical',
    parameters
  )
}
/**
 *  工作报告配置  默认进入页配置列表
 */
export function monthReportList() {
  return axios.formRequest.post('crm/website/setting/monthReportList', {})
}
/**
 *  工作报告配置  默认进入页配置  选择职位
 */
export function choiceJobByMonthReport(find_value) {
  return axios.formRequest.post('crm/website/setting/choiceJobByMonthReport', {
    find_value
  })
}
/**
 *  工作报告配置  默认进入页配置  添加默认进入页配置
 */
export function defaultPageSetting(parameters) {
  return axios.formRequest.post(
    'crm/website/setting/defaultPageSetting',
    parameters
  )
}
/**
 *  工作报告配置  默认进入页配置  删除默认进入页配置
 */
export function delMonthReport(default_page_setting_id) {
  return axios.formRequest.post('crm/website/setting/delMonthReport', {
    default_page_setting_id
  })
}
/**
 *  工作报告配置  默认进入页配置  编辑默认进入页配置
 */
export function editorMonthReport(parameters) {
  return axios.formRequest.post(
    'crm/website/setting/editorMonthReport',
    parameters
  )
}

/**
 *  导出中心 档案数据导出
 */
export function clientDataExport(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/clientDataExport',
    parameters
  )
}

/**
 *  导出中心 拜访(行为)数据导出
 */
export function visitExport(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/visitExport',
    parameters
  )
}

/**
 *  导出中心 评分建议导出
 */
export function scoreExport(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/scoreExport',
    parameters
  )
}

/**
 *  导出中心 档案受访导出
 */
export function clientVisitExport(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/clientVisitExport',
    parameters
  )
}

/**
 *  导出中心 休眠档案明细导出
 */
export function sleepClientExport(parameters) {
  return axios.formRequest.post(
    'crm/website/report_center/sleepClientExport',
    parameters
  )
}

/**
 *  档案操作是否能新增档案
 *  approval_flow_id is_can_add
 */
export function addClient(parameters) {
  return axios.formRequest.post('crm/website/setting/addClient', parameters)
}

/**
 *  导出工作周报
 *
 */
export function exportWeekReport(parameters) {
  return axios.formRequest.post(
    'crm/website/export/exportWeekReport',
    parameters
  )
}
/**
 *  导出工作日报
 *
 */
export function exportDayDetailReport(parameters) {
  return axios.formRequest.post(
    'crm/website/export/exportDayDetailReport',
    parameters
  )
}
/**
 *  工作统计
 *
 */
export function workStatisticsList(parameters) {
  return axios.formRequest.post(
    'crm/website/statistics/workStatisticsList',
    parameters
  )
}
/**
 *  导出工作统计
 *
 */
export function exportWorkStatistics(parameters) {
  return axios.formRequest.post(
    'crm/website/export/exportWorkStatistics',
    parameters
  )
}
/**
 *  获取活动附件
 */
export function activityEnclosureList(activity_id) {
  return axios.formRequest.post('crm/website/activity/activityEnclosureList', {
    activity_id
  })
}
/**
 *  代理商关系翻页列表
 *
 */
export function getPage(parameters) {
  return axios.formRequest.post(
    'masterdata/website/agency_relation/page',
    parameters
  )
}
/**
 *  代理商关系翻页列表
 *
 */
export function detail(agency_relation_id_dot, cls) {
  return axios.formRequest.post('masterdata/website/agency_relation/detail', {
    agency_relation_id_dot,
    cls
  })
}
/**
 *  批量导出工作日报接口
 *
 */
export function exportDayReport(parameter) {
  return axios.formRequest.post('crm/website/export/exportDayReport', parameter)
}
/**
 *  批量导出工作周报接口
 *
 */
export function exportBatchWeekReport(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportBatchWeekReport',
    parameter
  )
}
/**
 *  批量导出月报接口
 *
 */
export function exportBatchMonthReport(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportBatchMonthReport',
    parameter
  )
}
/**
 *  周计划统计导出接口
 *
 */
export function exportWeekReportStatistics(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportWeekReportStatistics',
    parameter
  )
}
/**
 *  审核翻页列表
 *
 */
export function approvalPage(parameters) {
  return axios.formRequest.post('crm/website/approval/page', parameters)
}
/**
 *  审核操作接口
 *
 */
export function approvalOperation(parameters) {
  return axios.formRequest.post('crm/website/approval/approval', parameters)
}
/**
 *  获取终端基础信息接口
 *
 */
export function baseInfo(client_id) {
  return axios.formRequest.post('masterdata/website/client/baseInfo', {
    client_id
  })
}
/**
 *  档案详情对比信息
 *
 */
export function getContrast(client_id) {
  return axios.formRequest.post('masterdata/website/client/getContrast', {
    client_id
  })
}

/**
 *  导出合规报告
 *
 */
export function complianceReport(parameters) {
  return axios.formRequest.post(
    'crm/website/export/complianceReport',
    parameters
  )
}
/**
 *  代理商等级列表
 *
 */
export function agentLevelList() {
  return axios.formRequest.post('masterdata/website/Setting/agentLevelList', {})
}
/**
 *  代理商等级配置
 *
 */
export function agentLevelSetting(level_json) {
  return axios.formRequest.post(
    'masterdata/website/Setting/agentLevelSetting',
    {
      level_json
    }
  )
  return axios.formRequest.post('crm/website/activity/activityEnclosureList', {
    activity_id
  })
}
/**
 *  新医院开发 -- 获取模版字段
 */
export function getTemplateFieldList(id) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/getTemplateFieldList',
    {
      id
    }
  )
}
/**
 *  新医院开发 -- 开发阶段列表
 */
export function developmentList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/developmentList',
    parameter
  )
}
/**
 *  新医院开发 -- 开发阶段配置
 */
export function developmentSet(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/developmentSet',
    parameter
  )
}

/**
 *  新医院开发 -- 开发阶段配置
 */
export function flowSetting(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital/flowSetting',
    parameter
  )
}

/**
 *  新医院开发列表
 */
export function hospitalPage(parameter) {
  return axios.formRequest.post('masterdata/website/Hospital/page', parameter)
}

/**
 *  新医院开发列表获取分页信息
 */
export function hospitalGetpagination(parameter) {
  return axios.formRequest.post(
    '/masterdata/website/Hospital/getListPageInfo',
    parameter
  )
}

/**
 *  维护开发状态模版下载
 */
export function editGoodsMapTemplate(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/editGoodsMapTemplate',
    parameter
  )
}

/**
 *  创建开发计划模版导出
 */
export function developmentPlanTemplate(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/developmentPlanTemplate',
    parameter
  )
}

/**
 *  产品适用部门列表
 */
export function goodsMapList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/goodsMapList',
    parameter
  )
}

/**
 *  品种列表
 */
export function hospitalGoodsList() {
  return axios.formRequest.post('masterdata/website/Hospital/goodsList', {})
}

/**
 *  添加产品
 */
export function hospitalAddGoods(paramater) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/addGoods',
    paramater
  )
}

/**
 *  产品部门配置删除
 */
export function goodsMapDel(paramater) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/goodsMapDel',
    paramater
  )
}

/**
 *  产品适用部门配置
 */
export function goodsMapSet(paramater) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/goodsMapSet',
    paramater
  )
}

/**
 *  新开发医院列表导出
 */
export function exportDevelopment(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/exportDevelopment',
    parameter
  )
}

/**
 *  新开发医院详情
 */
export function hospitalDetail(id) {
  return axios.formRequest.post('masterdata/website/Hospital/detail', {
    id
  })
}
/**
 *  新医院开发 模版字段配置
 */
export function templateFieldSet(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/templateFieldSet',
    parameter
  )
}
/**
 *  新医院开发 获取模版字段
 */
export function getNewHospitalTemplateFieldList(id) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/getTemplateFieldList',
    {
      id
    }
  )
}

/**
 *  新医院开发 开发状态筛选
 */
export function hospitalStatusList() {
  return axios.formRequest.post(
    'masterdata/website/Hospital/chooseDevelopment',
    {}
  )
}

/**
 *  新医院开发 开发模式筛选
 */
export function developModelList() {
  return axios.formRequest.post('masterdata/website/hospital/developModel', {})
}
/**
 *  审批中心 代理商关系详情
 */
export function detailInfo(agency_relation_id) {
  return axios.formRequest.post(
    'masterdata/website/agency_relation/detailInfo',
    {
      agency_relation_id
    }
  )
}
/**
 *  档案操作设置职位详情
 */
export function clientOpreateDetail(
  approval_flow_id = '',
  home_module_id = '',
  cls = ''
) {
  return axios.formRequest.post('crm/website/setting/clientOpreateDetail', {
    approval_flow_id,
    home_module_id,
    cls
  })
}
/**
 *  档案操作保存
 */
export function clientOpreateSave(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/clientOpreateSave',
    parameter
  )
}

/**
 *  审批中心 代理商关系详情
 */
export function hospitalGetFieldList(id) {
  return axios.formRequest.post('masterdata/website/Hospital/getFieldList', {
    id
  })
}
/**
 *  拜访清单列表
 */
export function complianceReportPage(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/complianceReportPage',
    parameter
  )
}
/**
 *  导出拜访清单
 */
export function exportComplianceReport(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportComplianceReport',
    parameter
  )
}
/**
 *  拜访清单详情
 */
//
export function complianceReportInfo(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/complianceReportInfo',
    parameter
  )
}
/**
 *  设置评分
 */
export function setScore(crm_compliance_report_id, score) {
  return axios.formRequest.post('crm/website/visit/setScore', {
    crm_compliance_report_id,
    score
  })
}
/**
 *  确认清单
 */
export function confirmComplianceReport(crm_compliance_report_id) {
  return axios.formRequest.post('crm/website/visit/confirmComplianceReport', {
    crm_compliance_report_id
  })
}
/**
 *  医生拜访模版 启用中列表
 */
export function enableList() {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/enableList',
    {}
  )
}
/**
 *  医生拜访模版 禁用列表
 */
export function disableList() {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/disableList',
    {}
  )
}
/**
 *  医生拜访模版 启用
 */
export function enable(id) {
  return axios.formRequest.post('masterdata/website/doctor_template/enable', {
    id
  })
}
/**
 *  医生拜访模版 品种筛选
 */
export function varietiesList() {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/varietiesList',
    {}
  )
}

/**
 *  拜访医生模版统计/明细 关键信息传达
 */
export function doctorTemplateStatistical(parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/statistical',
    parameter
  )
}

/**
 *  关键信息传达导出
 */
export function doctorTemplateExport(parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/export',
    parameter
  )
}

/**
 *  关键信息传达明细数据导出
 */
export function doctorTemplateExportDetail(parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/exportDetail',
    parameter
  )
}
/**
 *  医生拜访模版 禁用
 */
export function disable(id) {
  return axios.formRequest.post('masterdata/website/doctor_template/disable', {
    id
  })
}

/**
 *  oa 审批流模版列表
 */
export function oaFlowList() {
  return axios.formRequest.post('crm/website/oa/flowList', {})
}
/**
 *  oa 审批流 模版图标列表
 */
export function iconList() {
  return axios.formRequest.post('crm/website/template/iconList', {})
}
/**
 *  oa 审批流模版列表
 */
export function flowList() {
  return axios.formRequest.post('crm/website/oa/flowList', {})
}
/**
 *  oa 审批流模版列表（新）
 */
export function OAFlowList(paramater) {
  return axios.formRequest.post('crm/website/oa/flowList', paramater)
}
/**
 *  oa 模版数据列表
 */
export function flowDetailPage(parameter) {
  return axios.formRequest.post('crm/website/oa/flowDetailPage', parameter)
}
/**
 *  oa 审批流详情
 */
export function oaDetail(oa_id) {
  return axios.formRequest.post('crm/website/oa/detail', {
    oa_id
  })
}
/**
 *  oa 审批流转交
 */
export function handOver(parameter) {
  return axios.formRequest.post('crm/website/oa/handOver', parameter)
}

/**
 *  oa 审批流 获取模版控件
 */
export function getTemplateCondition(template_id) {
  return axios.formRequest.post('crm/website/oa/getTemplateCondition', {
    template_id
  })
}
/**
 *  oa 审批流导出
 */
export function oaExport(parameter) {
  return axios.formRequest.post('crm/website/export/oaExport', parameter)
}

/**
 *  问题反馈 列表
 */
export function questionPage(parameter) {
  return axios.formRequest.post('admin/website/question/page', parameter)
}

/**
 *  问题反馈 详情
 */
export function questionDetail(question_id) {
  return axios.formRequest.post('admin/website/question/detail', {
    question_id
  })
}
/**
 *  工业信息维护列表
 */
export function industrialPage(page, parameter = {}) {
  return axios.formRequest.post('flow/website/stats/industrialPage', {
    page,
    ...parameter
  })
}
/**
 *  工业信息维护列表 开启
 */
export function industrialEnable(id) {
  return axios.formRequest.post('flow/website/Stats/enable', {
    id
  })
}
/**
 *  工业信息维护列表 关闭
 */
export function industrialDisable(id) {
  return axios.formRequest.post('flow/website/Stats/disable', {
    id
  })
}
/**
 *  工业信息添加
 */
export function industrialAdd(parameter) {
  return axios.formRequest.post('flow/website/stats/industrialAdd', parameter)
}
/**
 *  工业信息编辑
 */
export function industrialEditor(parameter) {
  return axios.formRequest.post(
    'flow/website/stats/industrialEditor',
    parameter
  )
}
/**
 *  工业下拉列表
 */
export function industrialList(parameter = {}) {
  return axios.formRequest.post('flow/website/Stats/industrialList', parameter)
}
/**
 *  工业发货统计列表
 */
export function industrialSalePage(parameter) {
  return axios.formRequest.post(
    'flow/website/Stats/industrialSalePage',
    parameter
  )
}
/**
 *  工业发货导出
 */
export function industrialExport(parameter) {
  return axios.formRequest.post(
    'flow/website/Export/industrialExport',
    parameter
  )
}
/**
 *  代理商关系删除记录添加标记
 */
export function addTag(agency_relation_id) {
  return axios.formRequest.post('masterdata/website/agency_relation/addTag', {
    agency_relation_id
  })
}
/**
 *  拜访指标列表
 */
export function taskIndexPage(parameter) {
  return axios.formRequest.post('crm/website/visit/taskIndexPage', parameter)
}
/**
 *  拜访指标配置列表
 */
export function taskIndexList(type) {
  return axios.formRequest.post('crm/website/setting/taskIndexList', {
    type
  })
}
/**
 *  添加/编辑拜访指标
 */
export function addTaskIndex(parameter) {
  return axios.formRequest.post('crm/website/setting/addTaskIndex', parameter)
}
/**
 *  拜访指标导出
 */
export function exportTaskIndex(parameter) {
  return axios.formRequest.post('crm/website/export/exportTaskIndex', parameter)
}
/**
 *  拜访指标详情
 */
export function taskIndexInfo(parameter) {
  return axios.formRequest.post('crm/website/visit/taskIndexInfo', parameter)
}
/**
 *  医生拜访指标列表
 */
export function doctorTaskIndexPage(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/doctorTaskIndexPage',
    parameter
  )
}
/**
 *  医生拜访指标详情
 */
export function doctorTaskIndexInfo(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/doctorTaskIndexInfo',
    parameter
  )
}
/**
 *  档案操作日志
 *
 */
export function operateDetail(approval_id) {
  return axios.formRequest.post('masterdata/website/client/operateDetail', {
    approval_id
  })
}
/**
 *  九新考核列表
 *
 */
export function assessList() {
  return axios.formRequest.post('crm/website/Setting/assessList', {})
}
/**
 *  考核配置
 */
export function objectEditor(parameter) {
  return axios.formRequest.post('crm/website/Setting/objectEditor', parameter)
}
/**
 *  周计划指标列表
 */
export function weekPlanList(parameter) {
  return axios.formRequest.post('crm/website/Setting/weekPlanList', parameter)
}
/**
 *  周计划指标配置
 */
export function weekPlanSetting(parameter) {
  return axios.formRequest.post(
    'crm/website/Setting/weekPlanSetting',
    parameter
  )
}
/**
 *  绩效考核列表
 */
export function examPage(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/examPage',
    parameter
  )
}
/**
 *  绩效考核导出
 */
export function examExport(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/examExport',
    parameter
  )
}

/**
 *  绩效考核月报明细导出
 */
export function examDetailExport(parameter) {
  return axios.formRequest.post(
    'crm/website/hrjz_exam_score/examDetailExport',
    parameter
  )
}

/**
 *  考核详情
 */
export function examDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/examDetail',
    parameter
  )
}
/**
 *  分数发布
 */
export function scorePublic(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/scorePublic',
    parameter
  )
}
/**
 *  分数发布详情
 */
export function scorePublicDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/scorePublicDetail',
    parameter
  )
}
/**
 *  分数重算
 */
export function scoreRecalculation(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/scoreRecalculation',
    parameter
  )
}
/**
 *  分数修改
 */
export function scoreSave(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/scoreSave',
    parameter
  )
}
/**
 *  分数修改列表
 */
export function scoreSavePage(parameter) {
  return axios.formRequest.post(
    'crm/website/Hrjz_exam_score/scoreSavePage',
    parameter
  )
}
/**
 *  拜访客户列表
 */
export function visitTypeList() {
  return axios.formRequest.post('masterdata/website/setting/visitTypeList', {})
}
/**
 *  客户拜访类型设置保存
 */
export function visitTypeSetting(job_json, id) {
  return axios.formRequest.post('masterdata/website/setting/visitTypeSetting', {
    job_json,
    id
  })
}
/**
 *  问卷调查 翻页列表
 */
export function questionnairePage(parameter) {
  return axios.formRequest.post('crm/website/questionnaire/page', parameter)
}
/**
 *  问卷调查 问卷基础详情
 */
export function questionnaireGetTemplateInfo(parameter) {
  return axios.formRequest.post(
    'crm/website/questionnaire/getTemplateInfo',
    parameter
  )
}
/**
 *  问卷调查 统计信息
 */
export function recordList(parameter) {
  return axios.formRequest.post(
    'crm/website/questionnaire/recordList',
    parameter
  )
}
/**
 *  问卷调查 动态获取活动问卷列表
 */
export function dynamicActivityTemplateList(search_text) {
  return axios.formRequest.post('crm/website/questionnaire/templateList', {
    search_text
  })
}
/**
 *  问卷调查 导出
 */
export function exportQuestionnaire(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportQuestionnaire',
    parameter
  )
}

/**
 * 工业发货合计
 */
export function industrialSaleTotal(parameter) {
  return axios.formRequest.post(
    'flow/website/Stats/industrialSaleTotal',
    parameter
  )
}
/**
 * 敏感词列表
 */
export function filterWords() {
  return axios.formRequest.post('crm/website/setting/filterWords', {})
}
/**
 * 查看是否需要审批
 */
export function isNeedApproval(category) {
  return axios.formRequest.post('crm/website/approval/isNeedApproval', {
    category
  })
}

/**
 * 通知公告翻页
 */
export function noticePage(parameter) {
  return axios.formRequest.post('crm/website/notice/page', parameter)
}

/**
 * 通知公告删除
 */
export function noticeDel(parameter) {
  return axios.formRequest.post('crm/website/notice/del', parameter)
}

/**
 * 详情接口
 */
export function noticeDetail(parameter) {
  return axios.formRequest.post('crm/website/notice/detail', parameter)
}

/**
 * 发送回执
 */
export function noticeReceipt(crm_notice_id) {
  return axios.formRequest.post('crm/website/notice/receipt', {
    crm_notice_id
  })
}

/**
 * 通知公告添加
 */
export function noticeAdd(parameter) {
  return axios.formRequest.post('crm/website/notice/add', parameter)
}

/**
 * 通知公告编辑
 */
export function noticeEdit(parameter) {
  return axios.formRequest.post('crm/website/notice/edit', parameter)
}

/**
 * 通知公告编辑
 */
export function receiptList(parameter) {
  return axios.formRequest.post('crm/website/notice/receiptList', parameter)
}

/**
 * 通知公告接收人
 * scene 1-部门 2-职位
 * department_id
 * job_id
 * search_text
 */
export function getNoticeQuarterList(parameter) {
  return axios.formRequest.post('crm/website/notice/getQuartersList', parameter)
}

/**
 * 查看是否需要审批
 */
export function clientTotal(parameter) {
  return axios.formRequest.post('flow/website/stats/clientTotal', parameter)
}

/**
 * 考勤首页
 */
export function recordPage(parameter) {
  return axios.formRequest.post('crm/website/attendance/recordPage', parameter)
}

/**
 * 考勤组
 */
export function addressPage(parameter) {
  return axios.formRequest.post('crm/website/attendance/addressPage', parameter)
}

/**
 * 删除考勤组
 */
export function delAddress(parameter) {
  return axios.formRequest.post('crm/website/attendance/delAddress', parameter)
}

/**
 * 考勤组详情
 */
export function addressDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/attendance/addressDetail',
    parameter
  )
}

/**
 * 创建考勤地点
 */
export function addressAdd(parameter) {
  return axios.formRequest.post('crm/website/attendance/addressAdd', parameter)
}

/**
 * 编辑考勤地点
 */
export function addressEdit(parameter) {
  return axios.formRequest.post('crm/website/attendance/addressEdit', parameter)
}

/**
 * 日常考勤已选中部门id
 */
export function getSelectDep() {
  return axios.formRequest.post('crm/website/attendance/getSelectDep', {})
}

/**
 * 日常考勤导出 统计
 */
export function exportAttendanceRecord(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportAttendanceRecord',
    parameter
  )
}

/**
 * 日常考勤导出 明细
 */
export function exportAttendanceSign(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportAttendanceSign',
    parameter
  )
}

/**
 * 日常考勤导出 考勤绩效
 */
export function exportAttendancePerformance(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportAttendancePerformance',
    parameter
  )
}

/**
 * 配置档案查询优化
 */
export function globalSetSave(parameter) {
  return axios.formRequest.post(
    'masterdata/website/setting/globalSetSave',
    parameter
  )
}
/**
 * 医院上量
 */
export function hospitalMeasurePage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/page',
    parameter
  )
}
/**
 * 品种筛选（上量列表）
 */
export function hospitalMeasureGoodsList(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/goodsList',
    parameter
  )
}
/**
 * 医院上量导出
 */
export function exportHospitalMeasure(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/exportHospitalMeasure',
    parameter
  )
}
/**
 * 目标量模版导出
 */
export function exportPlanNumber(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/exportPlanNumber',
    parameter
  )
}
/**
 * 根据品种获取品规（详情品规筛选）
 */
export function hospitalMeasureVarietiesList(goods_id, client_id) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/varietiesList',
    {
      goods_id,
      client_id
    }
  )
}
/**
 * 上量详情
 */
export function hospitalMeasureDetail(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/detail',
    parameter
  )
}
/**
 * 计量单位转换详情
 */
export function installDetail(varieties_id) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/installDetail',
    {
      varieties_id
    }
  )
}
/**
 * 计量单位转换
 */
export function installUnit(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital_measure/installUnit',
    parameter
  )
}

/**
 * 勤奋榜列表
 */
export function diligencePage(parameter) {
  return axios.formRequest.post('masterdata/website/diligence/page', parameter)
}

/**
 * 积分明细
 */
export function diligenceScoreDetail(parameter) {
  return axios.formRequest.post(
    'masterdata/website/diligence/scoreDetail',
    parameter
  )
}

/**
 * 勤奋榜 导出
 */
export function diligenceExport(parameter) {
  return axios.formRequest.post(
    'masterdata/website/diligence/export',
    parameter
  )
}
/**
 * 活动形式列表
 */
export function activityFormPage(parameter) {
  return axios.formRequest.post(
    'crm/website/template/activityFormPage',
    parameter
  )
}
/**
 * 活动形式删除
 */
export function delActivityForm(activity_form_id) {
  return axios.formRequest.post('crm/website/template/delActivityForm', {
    activity_form_id
  })
}
/**
 * 活动形式详情
 */
export function activityFormInfo(activity_form_id) {
  return axios.formRequest.post('crm/website/template/activityFormInfo', {
    activity_form_id
  })
}
/**
 * 创建活动形式
 */
export function addActivityForm(parameter) {
  return axios.formRequest.post(
    'crm/website/template/addActivityForm',
    parameter
  )
}
/**
 * 编辑活动形式
 */
export function editorActivityForm(parameter) {
  return axios.formRequest.post(
    'crm/website/template/editorActivityForm',
    parameter
  )
}
/**
 * 筛选活动形式列表
 */
export function activityFormList() {
  return axios.formRequest.post('crm/website/activity/activityFormList', {})
}

/**
 *
 */
export function getActivityForm() {
  return axios.formRequest.post('crm/website/activity/getActivityForm', {})
}
/**
 * 新医院开发模版列表
 */
export function HospitalTemplateList() {
  return axios.formRequest.post('masterdata/website/Hospital/templateList', {})
}
/**
 * 新医院开发模版列表 删除
 */
export function HospitalTemplateDel(parameter) {
  return axios.formRequest.post('masterdata/website/Hospital/del', parameter)
}
/**
 * 已被选择的部门id列表
 */
export function HospitalGetSelectDep(id) {
  return axios.formRequest.post('masterdata/website/Hospital/getSelectDep', {
    id
  })
}
/**
 * 新医院开发合规报告导出
 */
export function exportDevelopmentPDF(parameter) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/exportDevelopmentPDF',
    parameter
  )
}

/**
 * 签到签离人员列表
 */
export function weekMapSignAccountPage(parameter) {
  return axios.formRequest.post(
    'crm/website/week_map/signAccountPage',
    parameter
  )
}

/**
 * 岗位筛选
 */
export function weekMapQuarterList(parameter) {
  return axios.formRequest.post('crm/website/week_map/quarterList', parameter)
}

/**
 * 工作地图排行榜
 */
export function weekMapRankingList(parameter) {
  return axios.formRequest.post('crm/website/week_map/ranking', parameter)
}

/**
 * 工作地图列表
 */
export function weekMapWeekList(parameter) {
  return axios.formRequest.post('crm/website/week_map/weekList', parameter)
}
/**
 * 根据部门获取模版
 */
export function getTemplateByDepartmentId(department_id) {
  return axios.formRequest.post(
    'masterdata/website/Hospital/getTemplateByDepartmentId',
    {
      department_id
    }
  )
}
/**
 * 新医院开发 编辑模版特殊处理
 */
export function updateGoodsType(choose_goods_type) {
  return axios.formRequest.post('crm/website/template/updateGoodsType', {
    choose_goods_type
  })
}
/**
 * 获取任务所有控件
 */
export function templateField(parameter) {
  return axios.formRequest.post('crm/website/visit/templateField', parameter)
}
/**
 *  选择产品
 *
 */
export function getAllGoods(name) {
  return axios.formRequest.post('masterdata/website/goods/getAllGoods', {
    name
  })
}
/**
 * 预警推送---模版列表
 */
export function warningTemplatePage(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/page',
    parameter
  )
}
/**
 * 预警推送---模版添加
 */
export function warningTemplateAdd(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/add',
    parameter
  )
}
/**
 * 预警推送---模版启用/停用
 */
export function warningTemplateStop(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/stop',
    parameter
  )
}
/**
 * 预警推送---模版删除
 */
export function warningTemplateDel(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/del',
    parameter
  )
}
/**
 * 预警推送---模版详情
 */
export function warningTemplateDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/detail',
    parameter
  )
}
/**
 * 预警推送---添加预警和个人能力分析纬度
 */
export function warningTemplateWarningItem(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_warning_template/warningItem',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按岗位列表
 */
export function costPageByQuarter(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costPageByQuarter',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医生列表
 */
export function costPageByDoctor(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costPageByDoctor',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医院列表
 */
export function costPageByHospital(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costPageByHospital',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按岗位详情
 */
export function costDetailByQuarter(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costDetailByQuarter',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医生详情
 */
export function costDetailByDoctor(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costDetailByDoctor',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医院详情
 */
export function costDetailByHospital(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costDetailByHospital',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按岗位总数据
 */
export function costTotalByQuarter(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costTotalByQuarter',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医生总数据
 */
export function costTotalByDoctor(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costTotalByDoctor',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医院总数据
 */
export function costTotalByHospital(parameter) {
  return axios.formRequest.post(
    'crm/website/statistics/costTotalByHospital',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按岗位导出
 */
export function costExportByQuarter(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportCostByQuarter',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医生导出
 */
export function costExportByDoctor(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportCostByDoctor',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医院导出
 */
export function costExportByHospital(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportCostByHospital',
    parameter
  )
}
/**
 * 费用统计---投入资源统计按医院导出
 */
export function setWeekReportContentSetting(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/setWeekReportContentSetting',
    parameter
  )
}
/**
 * 照片库模版id
 */
export function taskTempList(parameter) {
  return axios.formRequest.post('crm/website/crm_photo/taskTempList', parameter)
}
/**
 * 照片库照片列表
 */
export function photoPage(parameter) {
  return axios.formRequest.post('crm/website/crm_photo/page', parameter)
}
/**
 * 照片库拜访详情
 */
export function clientDetail(parameter) {
  return axios.formRequest.post('crm/website/crm_photo/clientDetail', parameter)
}
/**
 * 照片库活动详情
 */
export function formDetail(parameter) {
  return axios.formRequest.post('crm/website/crm_photo/formDetail', parameter)
}
/**
 * 照片库照片控件名称
 */
export function getPhoneTemplateField(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_photo/getPhoneTemplateField',
    parameter
  )
}
/**
 * 照片库照片列表导出
 */
export function photoExport(parameter) {
  return axios.formRequest.post('crm/website/crm_photo/export', parameter)
}

/**
 * 招商作战地图模版配置---模版列表
 */
export function battleMapTemplatePage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/page',
    parameter
  )
}

/**
 * 招商作战地图模版配置---启用停用模版
 */
export function battleMapTemplateOpen(parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/open',
    parameter
  )
}

/**
 * 招商作战地图模版配置---删除模版
 */
export function battleMapTemplateDel(parameter) {
  return axios.formRequest.post(
    'masterdata/website/battle_map_template/del',
    parameter
  )
}

/**
 *  档案操作是否能拍照创建
 *  approval_flow_id  is_can_photo
 */
export function addPhotoClient(parameters) {
  return axios.formRequest.post(
    'crm/website/setting/addPhotoClient',
    parameters
  )
}

/**
 *  医院开发确认开发完成
 */
export function developSure(parameters) {
  return axios.formRequest.post(
    'masterdata/website/hospital/developSure',
    parameters
  )
}

/**
 *  开发确认开启关闭&&开发确认职位
 */
export function SettingGlobalSave(parameters) {
  return axios.formRequest.post(
    'masterdata/website/setting/globalSave',
    parameters
  )
}

/**
 *  医院开发手动标识
 */
export function markTag(parameter) {
  return axios.formRequest.post(
    'masterdata/website/hospital/markTag',
    parameter
  )
}

/**
 *  oa办公排序
 */
export function markSort(parameter) {
  return axios.formRequest.post('crm/website/oa/markSort', parameter)
}

/**
 *  获取别名转化比例
 */
export function getAliasRateConfig(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/getAliasRateConfig',
    parameter
  )
}

/**
 *  设置别名转化比例接口
 */
export function setAliasRate(parameter) {
  return axios.formRequest.post('flow/website/setting/setAliasRate', parameter)
}

/**
 *  oa 开启关闭审批
 */
export function openApproval(paramater) {
  return axios.formRequest.post('crm/website/template/openApproval', paramater)
}

/**
 *  oa 判断该模板是否正在审批中
 */
export function isHaveApproval(paramater) {
  return axios.formRequest.post(
    'crm/website/template/isHaveApproval',
    paramater
  )
}

/**
 *  oa PDF下载
 */
export function exportDoctorAssistant(paramater) {
  return axios.formRequest.post(
    'crm/website/oa/exportDoctorAssistant',
    paramater
  )
}

/**
 *  流向关账获取月份配置
 */
export function getLockMonthList() {
  return axios.formRequest.post('flow/website/setting/getLockMonthList', {})
}

/**
 *  确认关账接口
 */
export function saveLockConfig(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/saveLockConfig',
    parameter
  )
}

/**
 *  核验流向有无负责人
 */
export function checkFlowQuarter(parameter) {
  return axios.formRequest.post(
    'flow/website/setting/checkFlowQuarter',
    parameter
  )
}

/**
 *  导出档案字段
 */
export function exportClientFieldList(parameter) {
  return axios.formRequest.post(
    'crm/website/template/exportClientFieldList',
    parameter
  )
}

/**
 *  查看数据范围权限配置 列表
 */
export function authLookList(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/job/authLookList',
    parameter
  )
}

/**
 *  查看数据范围权限配置 设置
 */
export function authSet(parameter) {
  return axios.formRequest.post('jurisdiction/website/job/authSet', parameter)
}
/**
 *  照片库查询医院开发列表
 */
export function clientDevelopmentDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_photo/clientDevelopmentDetail',
    parameter
  )
}

/**
 *  修改订单数量权限配置
 */
export function settingOrderJob(parameter) {
  return axios.formRequest.post(
    'order/website/contract/settingOrderJob',
    parameter
  )
}

/*
 *  医院开发指标 列表
 */
export function clientDevTaskIndexPage(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/clientDevTaskIndexPage',
    parameter
  )
}

/**
 *  医院开发指标 模板下载
 */
export function downloadClientDevIndexTemplate(parameter) {
  return axios.formRequest.post(
    '/crm/website/visit/downloadClientDevIndexTemplate',
    parameter
  )
}

/**
 *  医院开发指标 导出
 */
export function exportClientDevTaskIndex(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/exportClientDevTaskIndex',
    parameter
  )
}

/**
 *  关键信息传达通过产品获取模板
 */
export function getTemplatePage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/doctor_template/getTemplatePage',
    parameter
  )
}

/**
 * 关注医院名单 列表
 */
export function fouceHospitalPage(parameter) {
  return axios.formRequest.post('crm/website/hospital_list/page', parameter)
}
/**
 * 关注医院名单 批量删除
 */
export function fouceHospitalDel(parameter) {
  return axios.formRequest.post('crm/website/hospital_list/del', parameter)
}

/**
 * 关注医院名单 导出数据
 */
export function fouceHospitalExport(parameter) {
  return axios.formRequest.post('crm/website/hospital_list/export', parameter)
}

/**
 * 关注医院名单 下载模板
 */
export function exportHospitalList(parameter) {
  return axios.formRequest.post(
    'crm/website/export/exportHospitalList',
    parameter
  )
}
/**
 *  根据参数获取企业admin配置信息
 */
export function getAdminClientFieldByParams(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getAdminClientFieldByParams',
    parameter
  )
}

/**
 *  劳务上限配置分组列表
 */
export function getGroupList(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/getGroupList',
    parameter
  )
}

/**
 *  劳务上限配置详情
 */
export function serviceConfigDetail(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/detail',
    parameter
  )
}
/**
 *  劳务上限配置编辑
 */
export function serviceConfigEdit(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/edit',
    parameter
  )
}
/**
 *  根据控件类型获取活动形式列表
 */
export function getActivityFormByFieldTypeArr(parameter) {
  return axios.formRequest.post(
    'crm/website/template/getActivityFormByFieldTypeArr',
    parameter
  )
}
/**
 *  添加劳务上限配置
 */
export function serviceConfigAdd(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/add',
    parameter
  )
}
/**
 *  删除劳务上限配置
 */
export function serviceConfigDel(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/del',
    parameter
  )
}
/**
 *  修改劳务上限配置状态（启用、禁用）
 */
export function serviceConfigUpdateStatus(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/updateStatus',
    parameter
  )
}
/**
 *  劳务上限配置列表
 */
export function serviceConfigGetAllList(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_config/getAllList',
    parameter
  )
}

/**
 *  讲者讲课次数
 */
export function getJzStatPage(parameter) {
  return axios.formRequest.post(
    'masterdata/website/client/getJzStatPage',
    parameter
  )
}

/**
 *  劳务规则列表 + 异步导出
 */
export function serviceConfigGetRulesPage(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_rules/getRulesPage',
    parameter
  )
}

/**
 *  劳务规则列表批量删除
 */
export function serviceConfigBatchDel(parameter) {
  return axios.formRequest.post(
    'crm/website/labour_service_rules/batchDel',
    parameter
  )
}

/**
 * 有效活动回传点击
 */
export function activityCallbackClick(parameter) {
  return axios.formRequest.post(
    'crm/website/activity/activityCallbackClick',
    parameter
  )
}

/**
 * 根据类型获取crm模块表头设置列表
 */
export function getCrmHeaderList(parameter) {
  return axios.formRequest.post(
    'crm/website/setting/getCrmHeaderList',
    parameter
  )
}

/**
 * 设置crm模块表头
 */
export function setCrmHeader(parameter) {
  return axios.formRequest.post('crm/website/setting/setCrmHeader', parameter)
}

/**
 *  标准话术分页列表
 */
export function crmStandardScriptPage(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_standard_script/page',
    parameter
  )
}

/**
 *  根据参数获取模版列表
 */
export function getTemplateList(parameter) {
  return axios.formRequest.post(
    'crm/website/template/getTemplateList',
    parameter
  )
}

/**
 *  添加标准话术
 */
export function crmStandardScriptAdd(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_standard_script/add',
    parameter
  )
}

/**
 *  编辑标准话术
 */
export function crmStandardScriptEdit(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_standard_script/edit',
    parameter
  )
}

/**
 *  删除标准话术
 */
export function crmStandardScriptDel(parameter) {
  return axios.formRequest.post(
    'crm/website/crm_standard_script/del',
    parameter
  )
}

/**
 *  医生行为报表导出
 */
export function exportDoctorReport(parameter) {
  return axios.formRequest.post(
    'crm/website/activity_doctor_visit_report/exportDoctorReport',
    parameter
  )
}
/**
 *
 */
export function exportVisitReport(parameter) {
  return axios.formRequest.post(
    'crm/website/activity_doctor_visit_report/exportVisitReport',
    parameter
  )
}

/**
 *  活动行为报表导出
 */
export function exportActivityReport(parameter) {
  return axios.formRequest.post(
    'crm/website/activity_doctor_visit_report/exportActivityReport',
    parameter
  )
}

/**
 *  图片附件来源列表
 */
export function sourceFileList(parameter) {
  return axios.formRequest.post(
    'crm/website/source_file/sourceFileList',
    parameter
  )
}

/**
 *  图片附件来源导出
 */
export function sourceFileExport(parameter) {
  return axios.formRequest.post('crm/website/source_file/export', parameter)
}

// 获取物流信息
export function getLogisticsList(parameter) {
  return axios.formRequest.post('crm/website/oa/getLogisticsList', parameter)
}

// 执行审批
export function approval(parameter) {
  return axios.formRequest.post('crm/website/approval/approval', parameter)
}

// 编辑物流单号
export function saveLogistics(parameter) {
  return axios.formRequest.post('crm/website/oa/saveLogistics', parameter)
}

//编辑订单号
export function saveOrderCode(parameter) {
  return axios.formRequest.post('crm/website/oa/saveOrderCode', parameter)
}

/**
 *  模板列表
 */
export function crmTemplateList(parameter) {
  return axios.formRequest.post(
    'crm/website/data_report/templateList',
    parameter
  )
}

/**
 *  活动确认
 */
export function activityConfirm(parameter) {
  return axios.formRequest.post(
    'crm/website/activity/activityConfirm',
    parameter
  )
}

/**
 *  获取关联档案内容
 */
export function getClientMapData(parameter) {
  return axios.formRequest.post(
    'crm/website/template/getClientMapData',
    parameter
  )
}


/**
 *  医生拜访导出
 */
 export function exportDoctorVisit(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/exportDoctorVisit',
    parameter
  )
}

/**
 *  填写周月报字段内容
 */
export function saveReportCustom(parameter) {
  return axios.formRequest.post(
    'crm/website/report/saveReportCustom',
    parameter
  )
}
/**
 *  保存周月报字段内容 新
 */
export function submitReport(parameter) {
  return axios.formRequest.post(
    'crm/website/report/submitReport',
    parameter
  )
}
/**
 *  保存周总结/计划内容 新(没有模板的情况)
 */
export function saveReportContent(parameter) {
  return axios.formRequest.post(
    'crm/website/report/saveReportContent',
    parameter
  )
}

/**
 *  保存产品接口
 */
 export function getGoodsTitle(parameter) {
  return axios.formRequest.post(
    'masterdata/website/goods/getGoodsTitle',
    parameter
  )
}


/**
 *  导出月度里程数
 */
 export function exportMileage(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/exportMileage',
    parameter
  )
}

/**
 *  导出全数据取数导出
 */
export function allDataExport(parameter) {
  return axios.formRequest.post(
    'crm/website/visit/allDataExport',
    parameter
  )
}

